import InsurancePage from "./InsurancePage";

const MEDICAL_BENEFITS = [
  { rank: "Motivator", value: "1 Lakh (Self)" },
  { rank: "Senior Motivator", value: "1 Lakh (2 Adult)" },
  { rank: "Co.ordinator", value: "1 Lakh (2 Adult + 2 Child)" },
  { rank: "Senior Co.ordinator", value: "2 Lakh (Self)" },
  { rank: "Manager", value: "2 Lakh (2 Adult)" },
  { rank: "Director", value: "2 Lakh (2 Adult + 2 Child)" },
];

export default function MedicalInsurance() {
  return (
    <InsurancePage
      testId="medical-insurance-page"
      title="Medical Insurance"
      themeColor={{ header: "#dc2626", darker: "#b91c1c", tint: "#fef2f2" }}
      benefits={MEDICAL_BENEFITS}
    />
  );
}
